<div class="text-question-module" *ngIf="textQuestionCategories && textQuestionCategories.length > 0">
  <div class="title">{{ 'lang.reporting.textComments' | translate }}</div>
  <div *ngFor="let textQuestionCategory of textQuestionCategories">
    <div class="question-category">{{ textQuestionCategory.name }}</div>
    <div class="question" *ngFor="let question of textQuestionCategory.questions">
      <div class="question-name">{{ question.name }}</div>
      <div style="page-break-inside: avoid" class="row" *ngFor="let answer of question.answers; let i = index">
        <div class="number col-1">{{ i + 1 }}.</div>
        <div class="answer col-11" [ngClass]="{ 'self-assesment': answer.isSelfAssesment }">
          {{ answer.textValue
          }}<span *ngIf="answer.isSelfAssesment"> ({{ 'lang.reporting.selfAssesment' | translate }})</span>
        </div>
      </div>
    </div>
  </div>
</div>
